(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-banner"]) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.collection-description-expander__body');
      this.toggle = this.querySelector('.collection-description-expander__toggle');

      if (!this.body || !this.toggle) return;

      this.lines = parseInt(this.dataset.lines, 10) || 3;

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.init());
      } else {
        this.init();
      }
    }

    init() {
      let lineHeight = parseFloat(getComputedStyle(this.body).lineHeight);
      if (isNaN(lineHeight)) lineHeight = 24; // fallback if browser returns 'normal'

      const collapsedHeight = lineHeight * this.lines;

      // Only activate if content actually overflows the collapse threshold
      if (this.body.scrollHeight <= collapsedHeight) return;

      this.body.style.setProperty('--description-collapsed-height', `${collapsedHeight}px`);
      this.body.style.setProperty('--description-expanded-height', `${this.body.scrollHeight}px`);
      this.body.setAttribute('data-collapsible', '');
      this.toggle.removeAttribute('hidden');
      this.toggle.addEventListener('click', () => this.handleToggle());
    }

    handleToggle() {
      const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        let lineHeight = parseFloat(getComputedStyle(this.body).lineHeight);
        if (isNaN(lineHeight)) lineHeight = 24;
        this.body.style.setProperty('--description-collapsed-height', `${lineHeight * this.lines}px`);
        this.body.setAttribute('data-collapsible', '');
        this.body.removeAttribute('data-expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
      } else {
        this.body.style.setProperty('--description-expanded-height', `${this.body.scrollHeight}px`);
        this.body.setAttribute('data-expanded', '');
        this.toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.collection-description-expander__body');
      this.toggle = this.querySelector('.collection-description-expander__toggle');

      if (!this.body || !this.toggle) return;

      this.lines = parseInt(this.dataset.lines, 10) || 3;

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.init());
      } else {
        this.init();
      }
    }

    init() {
      let lineHeight = parseFloat(getComputedStyle(this.body).lineHeight);
      if (isNaN(lineHeight)) lineHeight = 24; // fallback if browser returns 'normal'

      const collapsedHeight = lineHeight * this.lines;

      // Only activate if content actually overflows the collapse threshold
      if (this.body.scrollHeight <= collapsedHeight) return;

      this.body.style.setProperty('--description-collapsed-height', `${collapsedHeight}px`);
      this.body.style.setProperty('--description-expanded-height', `${this.body.scrollHeight}px`);
      this.body.setAttribute('data-collapsible', '');
      this.toggle.removeAttribute('hidden');
      this.toggle.addEventListener('click', () => this.handleToggle());
    }

    handleToggle() {
      const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        let lineHeight = parseFloat(getComputedStyle(this.body).lineHeight);
        if (isNaN(lineHeight)) lineHeight = 24;
        this.body.style.setProperty('--description-collapsed-height', `${lineHeight * this.lines}px`);
        this.body.setAttribute('data-collapsible', '');
        this.body.removeAttribute('data-expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
      } else {
        this.body.style.setProperty('--description-expanded-height', `${this.body.scrollHeight}px`);
        this.body.setAttribute('data-expanded', '');
        this.toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();
})();
